import { render, staticRenderFns } from "./InfoMaterialUpload.vue?vue&type=template&id=2ff938c9&scoped=true&"
import script from "./InfoMaterialUpload.vue?vue&type=script&lang=js&"
export * from "./InfoMaterialUpload.vue?vue&type=script&lang=js&"
import style0 from "./InfoMaterialUpload.vue?vue&type=style&index=0&id=2ff938c9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff938c9",
  null
  
)

export default component.exports